// extracted by mini-css-extract-plugin
module.exports = {"button":"theme_button_1JW4T","message":"theme_message_3-sTy","title":"theme_title_CqAk_"};